// 组件对象，大写
import objectJsonEdit from './objectJsonEdit.vue'
export default objectJsonEdit
